import { useMemo } from 'react';

import type { SelectionList, ValidValueTypes } from '@revelio/iso-utility';

import { useAllCustomSkillLevels } from '../../../../../../shared/selection-lists/hooks/useAllCustomSkillLevels';
import { useSpecificCustomSkills } from '../../../../../../shared/selection-lists/hooks/useSpecificCustomSkills';
import { buildReportsCustomSkillSelectionLists } from './build-reports-custom-skill-selection-lists';
import { filterToSupportedLevels } from './custom-skills.helpers';

/**
 * Builds selection lists for Custom Skill taxonomy levels so BreadcrumbTree can render a tree.
 */
export const useReportsCustomSkills = (taxonomyId: number) => {
  const { levels } = useAllCustomSkillLevels();

  const { data, fetching } = useSpecificCustomSkills({
    levelIds: filterToSupportedLevels(levels).map((l) => l.level_id),
    taxonomyId: taxonomyId,
  });

  const lists = useMemo<SelectionList<ValidValueTypes>[]>(() => {
    if (!data || data.length === 0) return [];
    return buildReportsCustomSkillSelectionLists(data);
  }, [data]);

  return { lists, isLoading: fetching };
};
